package settings.syndrome.components

import antd.checkbox.checkboxGroup
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.layout.space
import antd.message.message
import antd.modal.modal
import antd.select.SelectComponent
import antd.select.MultiSelectComponent
import antd.select.multiSelect
import antd.select.optGroup
import antd.select.option
import antd.select.select
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.SyndromeIndication
import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptom
import com.jingfangpai.common.orm.mapping.enums.*
import com.jingfangpai.syndrome.model.SyndromeIndicationDetail
import external.select.filterOptionFun
import external.toJsObject
import kotlinext.js.Object
import kotlinext.js.js
import kotlinext.js.jsObject
import react.*
import react.dom.div

external interface SyndromeIndicationEditModalProps : RProps {
    var isVisible:Boolean
    var changeVisibility:(Boolean)->Unit
    var syndromeIndication:SyndromeIndication
    var indicationOptions:Array<CascadedOption<String>>
    var save:(syndromeIndication:SyndromeIndication, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<SyndromeIndication>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
    var onSaved:()->Unit
}

data class SyndromeIndicationEditModalContextData(var placeHolderFunction: (param: String) -> Unit)

val SyndromeIndicationEditModal = functionalComponent<SyndromeIndicationEditModalProps> { props ->

    val (editingSyndromeIndication,setEditingSyndromeIndication) = useState(props.syndromeIndication)
    //val (editingSyndromeIndicationSignSymptoms,setEditingSyndromeIndicationSignSymptoms) = useState(props.signSyptoms)


    useEffectOnce { }

    useEffect(props.syndromeIndication){
        setEditingSyndromeIndication(props.syndromeIndication)
    }

    /*useEffect(props.signSyptoms){
        setEditingSyndromeIndicationSignSymptoms(props.signSyptoms)
    }*/

    div("SyndromeIndicationEditModal") {
        modal {
            attrs{
                style = kotlinext.js.js {
                    width = "840px"
                }
                width = "840px"
                visible = props.isVisible
                onCancel = {
                    props.changeVisibility(false)
                }
                onOk = {
                    props.save(editingSyndromeIndication,{resp->
                        if(resp.ok()){
                            props.changeVisibility(false)
                            props.onSaved()
                        }else{
                            message.error("出错了，${resp.message?:"未知错误"}")
                        }
                    },{
                        console.log(it)
                        message.error("出错了，${it.message?:"未知错误"}")
                    })
                }
                cancelText = "取消"
                okText = "保存"
            }
            form{
                attrs{
                    layout = "horizontal"
                    labelCol = jsObject{ span = 4 }
                    wrapperCol = jsObject{ span= 20 }
                }
                formItem {
                    attrs{
                        label = "名称"
                    }
                    input {
                        attrs {
                            value = editingSyndromeIndication?.name?:""
                            placeholder = "请填写适应证名或适用方名称"
                            onChange = {event: dynamic ->
                                val entity = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                entity.name = event.target.value as String
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "基础适应证"
                    }
                    select<String, SelectComponent<String>> {
                        attrs {
                            showSearch = true
                            style = kotlinext.js.js { width = 200 }
                            value = editingSyndromeIndication.signSymptomBaseIndicationId
                            labelInValue = false
                            placeholder = "基础适应证"
                            optionLabelProp = "label"
                            filterOption = ::filterOptionFun
                            onChange = { value: String, option: dynamic ->
                                console.log("option",option)
                                console.log("Before Object.assign - editingSyndromeIndication:", editingSyndromeIndication)
                                console.log("Stack trace for SyndromeIndication construction")
                                val symptom = Object.assign(SyndromeIndication(),editingSyndromeIndication)
                                console.log("After Object.assign - symptom:", symptom)
                                symptom.signSymptomBaseIndicationId = value
                                //symptom.name = option.label
                                setEditingSyndromeIndication(symptom)
                            }
                        }
                        option {
                            attrs{
                                label = "无"
                                value = null
                            }
                            +"无"
                        }
                        props.indicationOptions.forEach { optGroup ->
                            optGroup {
                                attrs{
                                    label = "${optGroup.label}"
                                }
                                optGroup.children?.forEach { opt->
                                    if(opt.value != editingSyndromeIndication.id) {
                                        option {
                                            attrs {
                                                label = "${opt.label}"
                                                value = "${opt.value}"
                                            }
                                            +"${opt.label}"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "出处"
                    }
                    input {
                        attrs {
                            value = editingSyndromeIndication?.source?:""
                            placeholder = "请填写出处"
                            onChange = {event: dynamic ->
                                val entity = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                entity.source = event.target.value as String
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "病名"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.disease?.toTypedArray()
                            options = SyndromeIndicationDisease.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.disease = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "表证"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.exteriorPathogenesis?.toTypedArray()
                            options = SyndromeIndicationExteriorPathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.exteriorPathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }

                }
                formItem {
                    attrs{
                        label = "里证"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.interiorPathogenesis?.toTypedArray()
                            options = SyndromeIndicationInteriorPathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.interiorPathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }

                formItem {
                    attrs{
                        label = "半表半里证"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.intermediatePathogenesis?.toTypedArray()
                            options = SyndromeIndicationIntermediatePathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.intermediatePathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "上焦"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.upperPathogenesis?.toTypedArray()
                            options = SyndromeIndicationUpperPathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.upperPathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "中焦"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.middlePathogenesis?.toTypedArray()
                            options = SyndromeIndicationMiddlePathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.middlePathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "下焦"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.lowerPathogenesis?.toTypedArray()
                            options = SyndromeIndicationLowerPathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.lowerPathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "整体病机"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.overallPathogenesis?.toTypedArray()
                            options = SyndromeIndicationOverallPathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.overallPathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "脏腑病机"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.zangfuPathogenesis?.toTypedArray()
                            options = SyndromeIndicationZangfuPathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.zangfuPathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "脏腑兼证"
                    }
                    checkboxGroup {
                        attrs {
                            value =  editingSyndromeIndication.zangfuCombinedPathogenesis?.toTypedArray()
                            options = SyndromeIndicationZangfuCombinedPathogenesis.values().map{ CascadedOption(it.getLiteral(), it) }.toTypedArray()
                            onChange = { value ->
                                val entity = Object.assign(SyndromeIndicationDetail(), editingSyndromeIndication)
                                entity.zangfuCombinedPathogenesis = value.toSet()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                        
                formItem {
                    attrs{
                        label = "其他病机"
                    }
                    input {
                        attrs {
                            value = editingSyndromeIndication?.pathogenesisOthers?:""
                            placeholder = "请填写其他病机"
                            onChange = {event: dynamic ->
                                val entity = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                entity.pathogenesisOthers = event.target.value as String
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "适应证描述"
                    }
                    textArea {
                        attrs {
                            value = editingSyndromeIndication.description ?:""
                            rows = 3
                            onChange = {event: dynamic ->
                                val entity = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                entity.description = event.target.value as String
                                setEditingSyndromeIndication(entity)
                            }
                        }
                    }
                }

                /*formItem{
                    attrs{
                        label = "相关症状"
                    }
                    console.log("editingSyndromeIndicationSignSymptoms",editingSyndromeIndication.symptoms)
                    editingSyndromeIndication.symptoms.forEachIndexed { index, syndromeIndicationSignSymptomDetail ->
                        space {
                            attrs{
                                key = "signSymptom-${index}"
                                style = js{
                                    display = "flex"
                                    marginBottom = "8"
                                }
                                align = "baseline"
                            }
                            formItem {
                                select<String, SelectComponent<String>> {
                                    attrs {
                                        showSearch = true
                                        style = kotlinext.js.js { width = 200 }
                                        value = syndromeIndicationSignSymptomDetail.symptomId
                                        onChange = { value: String, option: Any ->
                                            val _editing = Object.assign(SyndromeIndicationSignSymptomDetail(), syndromeIndicationSignSymptomDetail)
                                            _editing.symptomId = value
                                            //setSignSymptom(_editing)
                                        }
                                    }
                                    SignSymptomName.values().forEach { name ->
                                        option {
                                            attrs.value = name.getLiteral()
                                            +name.getLiteral()
                                        }
                                    }
                                }
                            }
                            formItem {
                                radioGroup {
                                    attrs{
                                        value = syndromeIndicationSignSymptomDetail.constrain
                                        onChange = { event->
                                            val symptoms = mutableSetOf<SyndromeIndicationSignSymptomDetail>()
                                            editingSyndromeIndication.symptoms.forEachIndexed { idx, syndromeIndicationSignSymptomDetail ->
                                                if(idx == index){
                                                    syndromeIndicationSignSymptomDetail.constrain =  event.target.value
                                                }
                                                symptoms += syndromeIndicationSignSymptomDetail
                                            }
                                            val _indication = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                            _indication.symptoms = symptoms
                                            setEditingSyndromeIndication(_indication)
                                        }
                                    }
                                    radioButton {
                                        attrs{
                                            value = null
                                        }
                                        +"可见"
                                    }
                                    SyndromeIndicationSignSymptomConstrain.values().forEach {  constrain ->
                                        radioButton {
                                            attrs{
                                                value = constrain
                                            }
                                            +"${constrain.getLiteral()}"
                                        }
                                    }
                                }
                            }

                            formItem {
                                attrs{
                                    label = "出处"
                                }
                                input {
                                    attrs {
                                        value = syndromeIndicationSignSymptomDetail.source?:""
                                        placeholder = "请填写出处"
                                        onChange = {event: dynamic ->
                                            val symptoms = mutableSetOf<SyndromeIndicationSignSymptomDetail>()
                                            editingSyndromeIndication.symptoms.forEachIndexed { idx, syndromeIndicationSignSymptomDetail ->
                                                if(idx == index){
                                                    syndromeIndicationSignSymptomDetail.source =  event.target.value
                                                }
                                                symptoms += syndromeIndicationSignSymptomDetail
                                            }
                                            val _indication = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                            _indication.symptoms = symptoms
                                            setEditingSyndromeIndication(_indication)
                                        }
                                    }
                                }
                            }

                            button {
                                attrs{
                                    onClick = {

                                    }
                                }
                                minusCircleOutlined{}
                            }
                        }
                    }

                    formItem{
                        button {
                            attrs {
                                type = "dashed"
                                onClick = {
                                    val _symptoms = Object.assign(mutableSetOf(),editingSyndromeIndication.symptoms)
                                    _symptoms += SyndromeIndicationSignSymptomDetail().apply{
                                        syndromeIndicationId = editingSyndromeIndication.id
                                    }
                                    val _indication = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                    _indication.symptoms = _symptoms
                                    setEditingSyndromeIndication(_indication)
                                }
                                block = true
                                icon = buildElement{
                                    plusOutlined{}
                                }
                            }
                            +"添加症状"
                        }
                    }
                }*/

                formItem {
                    attrs{
                        label = "排序"
                    }

                    select<String, SelectComponent<String>> {
                        attrs {
                            mode = "default"
                            labelInValue = false
                            value = "${editingSyndromeIndication.weight?:""}"
                            placeholder = "排序位置"
                            optionLabelProp = "label"
                            filterOption = ::filterOptionFun
                            //onSearch = fetchUser
                            onChange = { selected: String, any: Any ->
                                val entity = Object.assign(SyndromeIndicationDetail(),editingSyndromeIndication)
                                entity.weight = selected.toInt()
                                setEditingSyndromeIndication(entity)
                            }
                            style = js { width = "100%" }
                        }
                        IntRange(1,30).forEach { opt ->
                            option {
                                attrs{
                                    label = "${opt}"
                                    value = "${opt}"
                                }
                                +"${opt}"
                            }
                    }
                }

                    /*radioGroup{
                        attrs{
                            value = "${editingSyndromeIndication.weight?:""}"
                            onChange = { event:dynamic ->
                                val entity = Object.assign(SyndromeIndication(),editingSyndromeIndication)
                                entity.weight = (event.target.value as String).toInt()
                                setEditingSyndromeIndication(entity)
                            }
                        }
                        IntRange(1,30).forEach { idx ->
                            radioButton {
                                attrs.value = "${idx}"
                                +"${idx}"
                            }
                        }
                    }*/
                }

            }
        }
    }
}
